module.exports = __webpack_public_path__ + "img/viagens_diarias_reembolsos.d310ce8a.png";